import {
  Outlet,
  createFileRoute,
  retainSearchParams,
} from '@tanstack/react-router'
import * as v from 'valibot'

import { LearnpathsSummaryDetailsPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsPanel/LearnpathsSummaryDetailsPanel'

const searchSchema = v.object({
  only_direct_learners_stats: v.optional(v.boolean()),
})

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId',
)({
  validateSearch: searchSchema,
  search: {
    middlewares: [retainSearchParams(['only_direct_learners_stats'])],
  },
  component: DetailsLayout,
})

function DetailsLayout() {
  return (
    <LearnpathsSummaryDetailsPanel>
      <Outlet />
    </LearnpathsSummaryDetailsPanel>
  )
}
